<template>
    <div class="o-dashboard">

        <c-tabs :tabs="tabs" @selectTab="setTab">

            <c-tab v-if="tab == 'asns'">
                <c-table
                    :filters="[ 
                        { name: 'client', label: 'Alle eindklanten', options: endClients },
                    ]"
                    ref="table"
                    :columns="columns"
                    :endpoint="'/api/asns'"
                    :placeholder="'Zoeken op eindklant, ordernummer of topdesk nummer'">
                </c-table>
            </c-tab>

            <c-tab v-if="tab == 'archive'">
                <c-table
                    :filters="[ 
                        { name: 'client', label: 'Alle eindklanten', options: endClients },
                    ]"
                    ref="table"
                    :columns="columns"
                    :endpoint="'/api/asns-archive'"
                    :placeholder="'Zoeken op eindklant, ordernummer of topdesk nummer'"
                    :loadMore="true">
                </c-table>

            </c-tab>
        </c-tabs>

        <c-new-prenotification
            v-show="modal"
            @close="modal=false"
            @added="load"
            :size="'medium'"
            :title="'Nieuwe voormelding'">
        </c-new-prenotification>
        
    </div>
</template>

<script>
import View from '@mixins/View';
import Form from '@mixins/Form';
import CTable from '@components/table/Table';
import CNewPrenotification from '@app/modals/NewPrenotification';
import CTabs from '@components/tab/Container';
import CTab from '@components/tab/Element';

export default {
    mixins: [View, Form],
    components: {CTable, CNewPrenotification, CTabs, CTab},
    data() {
        return {
            modal: false,
            tabs: [
				{ name:'asns', label: 'Voormeldingen' },
				{ name:'archive', label: 'Afgeronde voormeldingen' }
			]
        }
    },
    methods: {
        setTab(tab){
            this.tab = tab
        },
        openModal() {
            this.modal = true;
        },
        load() {
            this.$refs.table.load();
        },
        exportAsnProducts() {

            let filterParams = '';
            for (const [key, value] of Object.entries(this.$refs.table.selection.filters)) {
                if (value !== null && value !== '') {
                    filterParams += `&filters[${encodeURIComponent(key)}]=${encodeURIComponent(value)}`;
                }
            }

            const link = document.createElement('a');
            link.href = '/api/exportasnproductscsv?search=' + this.$refs.table.selection.search.all + '&sort=' + this.$refs.table.sort.column + '&order=' + this.$refs.table.sort.direction + filterParams;
            document.body.appendChild(link);
            link.click();
        }
    },
    beforeUnmount() {
        this.$store.dispatch("listener/off", {
            event: 'new-prenotification',
            listener: this.openModal
        });
        this.$store.dispatch('listener/off', {
            event: 'export',
            listener: this.exportAsnProducts
        });
    },
    created() {
        this.$store.dispatch("listener/on", {
            event: 'new-prenotification',
            listener: this.openModal
        });
        this.$store.dispatch('listener/on', {
            event: 'export',
            listener: this.exportAsnProducts
        });
    },
    computed: {
        columns() {
            let columns = [
                {name: 'client.name', label: 'Eindklant', sortable: true, sort: true},
                {name: 'w_number', label: 'Topdesknummer', sortable: true},
                {name: 'reference', label: 'Ordernummer', sortable: true},
                {name: 'expected_sum', label: 'Aantal', sortable: true},
                {name: 'expected', component: 'CColumnDatetime', label: 'Leverdatum', sortable: true},
                {name: 'created_at', component: 'CColumnDateWithHours', label: 'Aanmelddatum', sortable: true},
                {name: "id", label: "", component: 'CColumnButton', props: {route: 'PreNotificationProducts'}},
            ];

            return columns;
        },
        endClients() {
			return this.$store.getters['filters/allEndClients'];
		}
    },
    beforeMount(){
        this.$store.dispatch('filters/fetchEndClients');
    }

}
</script>
